import { render, staticRenderFns } from "./Statisticas.vue?vue&type=template&id=45eae92f"
import script from "./Statisticas.vue?vue&type=script&lang=js"
export * from "./Statisticas.vue?vue&type=script&lang=js"
import style0 from "./Statisticas.vue?vue&type=style&index=0&id=45eae92f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports